module.exports = __webpack_public_path__ + "static/img/dwg.f1728b6f.png";